import { GetOperationsResultData } from '@indigohive/cogfy-types/endpoints/getOperations'
import { useMemo } from 'react'
import { FieldType } from '@indigohive/cogfy-types'
import { FieldsMenuOperationItem } from '../FieldsMenuOperationItem/'
import { MAP_LOGO_BY_MODULE } from '../../../../../../components/__common/map-logo-by-provider'
import { ProviderName } from '@indigohive/cogfy-providers'

type FieldsMenuModuleProviderProps = {
  operations: GetOperationsResultData[]
  onClick?: (fieldType: FieldType, fieldOperation?: string, displayName?: string) => void
}

export function FieldsMenuModuleProvider (props: FieldsMenuModuleProviderProps) {
  const { operations, onClick } = props

  const modulesProviders = useMemo(
    () => [...new Set(operations.filter(operation => operation.module).map(operation => operation.module))],
    [operations]
  )
  return (
    <>
      {modulesProviders.map(
        module => {
          const moduleName = module?.toLocaleLowerCase().replace(' ', '')
          const imageSrc = MAP_LOGO_BY_MODULE[moduleName as ProviderName]
          return (
            <>
              {module && (
                <li key={module} className="menu-title">
                  <div className="flex gap-2 items-center mt-4">
                    {imageSrc && (
                      <img
                        src={imageSrc}
                        alt={`${module}-logo`}
                        className="size-7 rounded-md"
                      />
                    )}
                    <span className="grow">{module}</span>
                  </div>
                </li>
              )}
              {operations
                .filter(operation => operation.module === module)
                .map(operation => {
                  return (
                    <FieldsMenuOperationItem
                      key={operation.name}
                      operation={operation}
                      onClick={onClick}
                    />
                  )
                })}
            </>
          )
        }
      )}
    </>
  )
}
